import {
  GRAY_2,
  GRAY_LIGHT,
  TRIMBLE_GRAY,
  TRIMBLE_GRAY_CONTENT,
} from './mc-tokens';
import {
  MC_COMMENTS_ATTACHMENT_LIST_RESET_CSS,
  MC_COMMENTS_ATTACHMENT_ROW_CSS,
  MC_COMMENTS_ATTACHMENT_ROW_INTERACTIVE_CSS,
} from './mc-comments-attachment.css';
import { MC_COMMENTS_STATES_CSS } from './mc-comments-states.css';

export {
  MC_COMMENTS_ATTACHMENT_LIST_RESET_CSS,
  MC_COMMENTS_ATTACHMENT_ROW_CSS,
  MC_COMMENTS_ATTACHMENT_ROW_INTERACTIVE_CSS,
} from './mc-comments-attachment.css';

export const MODUS_COMMENTS_STYLESHEET = `
  .mc-comments {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    color: ${TRIMBLE_GRAY};
    background: #fff;
    overflow-x: hidden;
  }

  .modus-wc-btn.modus-wc-btn-borderless.modus-wc-btn-disabled,
  .modus-wc-btn.modus-wc-btn-borderless:disabled,
  .modus-wc-btn.modus-wc-btn-borderless[disabled] {
    background-color: transparent !important;
    opacity: 0.5;
  }
    
  .mc-comments.is-disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  .mc-comments__section-header {  
    padding: 0.75rem 1rem 0.5rem;
  }

  .mc-comments__list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .mc-comments__item {
    padding: 0;
    border-bottom: 1px solid ${GRAY_2};
  }

  .mc-comments__item:last-child {
    border-bottom: none;
  }

  .mc-comments__item-row {
    display: flex;
    align-items: flex-start;
    gap: 0.50rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0.75rem 1rem;
  }

  .mc-comments__item:has(.mc-comments__saved-attachments) .mc-comments__item-row,
  .mc-comments__item:has(.mc-comments__actions) .mc-comments__item-row,
  .mc-comments__item:has(.mc-comments__item-edit) .mc-comments__item-row,
  .mc-comments__item:has(.mc-comments__item-body) .mc-comments__item-row {
    padding-bottom: 0;
  }

  .mc-comments__item--other .mc-comments__item-row {
    justify-content: flex-start;
  }

  .mc-comments__item--own .mc-comments__item-row {
    justify-content: flex-end;
  }

  .mc-comments__avatar {
    flex: 0 0 auto;
    display: flex;
    align-items: flex-start;
    & modus-wc-avatar .modus-wc-avatar .modus-wc-w-16 .initials {
      font-size: var(--modus-wc-font-size-md);
      line-height: var(--modus-wc-line-height-md);
    }
  }

  .mc-comments__avatar--photo .mc-comments__avatar-img,
  .mc-comments__avatar--photo img {
    display: block;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    object-fit: cover;
  }

  .mc-comments__item-content {
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1 1 auto;
  }

  .mc-comments__item-header {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    & tc-custom-tooltip {
      width: 100%;
    }
  }

  .mc-comments__item--own .mc-comments__item-header {
    align-items: flex-end;
    text-align: right;
  }

  .mc-comments__item--own .mc-comments__item-header tc-modus-typography,
  .mc-comments__item--own .mc-comments__item-header modus-wc-typography,
  .mc-comments__item--own .mc-comments__item-header tc-custom-tooltip {
    text-align: right;
    & .modus-wc-typography {
      white-space: nowrap;
      text-overflow: ellipsis; 
      overflow: hidden;
    }
  }

  .mc-comments__item-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.375rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0.5rem 1rem;
    text-align: left;
  }

  .mc-comments__item-body tc-modus-typography,
  .mc-comments__item-body modus-wc-typography,
  .mc-comments__item--own .mc-comments__item-body tc-modus-typography,
  .mc-comments__item--own .mc-comments__item-body modus-wc-typography {
    text-align: left;
    width: 100%;
  }

  .mc-comments__timestamp {
    --modus-wc-color-base-content-low-contrast: ${TRIMBLE_GRAY_CONTENT};
    color: var(--modus-wc-color-base-content-low-contrast);
    font-weight: var(--modus-wc-font-weight-light) !important;
  }

  .mc-comments__body {
    word-break: break-word;
    white-space: pre-wrap;
    text-align: left;
  }

  .mc-comments__saved-attachments {
    width: 100%;
    box-sizing: border-box;
    padding: 0;
  }

  ${MC_COMMENTS_ATTACHMENT_LIST_RESET_CSS}

  ${MC_COMMENTS_ATTACHMENT_ROW_CSS}

  ${MC_COMMENTS_ATTACHMENT_ROW_INTERACTIVE_CSS}

  .mc-comments__saved-attachments .limit-visible-items__toggle,
  .mc-comments__list > .limit-visible-items__toggle {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 0.5rem 1rem;
    box-sizing: border-box;
  }

  .mc-comments__list > .limit-visible-items__toggle {
    border-bottom: 1px solid ${GRAY_2};
  }

  .mc-comments__saved-attachments .limit-visible-items__toggle tc-button,
  .mc-comments__saved-attachments .limit-visible-items__toggle modus-wc-button,
  .mc-comments__list > .limit-visible-items__toggle tc-button,
  .mc-comments__list > .limit-visible-items__toggle modus-wc-button {
    width: auto !important;
    display: inline-flex !important;
    flex: 0 0 auto;
  }

  .mc-comments__attachments {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    width: 100%;
  }

  .mc-comments__attachment {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.375rem 0.5rem;
    background: ${GRAY_LIGHT};
    border-radius: 0.25rem;
  }

  .mc-comments__attachment-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mc-comments__attachment modus-wc-icon i,
  .mc-comments__edit-attach modus-wc-icon i,
  .mc-comments__edit-attachments modus-wc-icon i {
    height: 1rem;
    width: 1rem;
  }

  .mc-comments__actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 0.75rem;
    margin-top: 0.375rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0 1rem 0.75rem;
  }

  .mc-comments__edit-actions {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .mc-comments__edit-actions-start {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    flex: 0 0 auto;
  }

  .mc-comments__edit-attach {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
  }

  .mc-comments tc-button,
  .mc-comments modus-wc-button {
    width: auto;
    display: inline-flex;
    flex: 0 0 auto;
  }

  .mc-comments__edit-box {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 0.25rem;
    background-color: ${GRAY_LIGHT};
    border-radius: 0.125rem;
  }

  .mc-comments__edit-box tc-custom-textarea,
  .mc-comments__edit-box modus-wc-textarea,
  .mc-comments__edit-textarea {
    display: block;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .mc-comments__edit-box modus-wc-textarea textarea,
  .mc-comments__edit-textarea textarea {
    display: block;
    width: 100%;
    max-width: 100%;
    min-height: 3rem;
    padding: 0.375rem 0.5rem;
    box-sizing: border-box;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: ${TRIMBLE_GRAY};
    resize: vertical;
    border: 0.0625rem solid ${GRAY_2};
    border-bottom: 0.0625rem solid ${TRIMBLE_GRAY};
    background-color: #fff;
    outline: none;
    box-shadow: none;
    border-radius: 0;
  }

  .mc-comments__edit-attachments {
    width: 100%;
    box-sizing: border-box;
  }

  .mc-comments__item--editing {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
  }

  .mc-comments__item-edit {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 0 1rem 0.75rem;
  }

  .mc-comments__item--own.mc-comments__item--editing .mc-comments__item-header {
    align-items: flex-end;
  }

  ${MC_COMMENTS_STATES_CSS}
`;
